import { clsx } from 'clsx'

interface EyebrowProps {
  children: React.ReactNode
  /** `gold` is for dark surfaces only (never gold text on white). */
  tone?: 'muted' | 'ink' | 'gold'
  className?: string
  /** For `aria-labelledby` when the kicker is a section's accessible name. */
  id?: string
}

/**
 * Editorial uppercase kicker that sits above headings and section content.
 * Carries the redesign's rhythm — muted, tracked-out, bold.
 */
export function Eyebrow({ children, tone = 'muted', className, id }: EyebrowProps) {
  return (
    <div
      id={id}
      className={clsx(
        'text-[12px] font-extrabold uppercase tracking-[0.12em]',
        {
          'text-text-muted': tone === 'muted',
          'text-brand-text': tone === 'ink',
          'text-brand-primary': tone === 'gold',
        },
        className
      )}
    >
      {children}
    </div>
  )
}
